/**
 * Initialize Gallery Grid Lightbox.
 */
document.addEventListener( 'DOMContentLoaded', () => {
	const blocks = document.querySelectorAll( '.mu-gallery-grid-block' );

	if ( ! blocks.length ) {
		return;
	}

	blocks.forEach( ( block ) => {
		const images = [ ...block.querySelectorAll( '.mu-gallery-grid-items img' ) ];
		const overlay = block.querySelector( '.mu-gallery-grid-lightbox' );

		if ( ! images.length || ! overlay ) {
			return;
		}

		const backdrop = overlay.querySelector( '.mu-gallery-grid-backdrop' );
		const closeBtn = overlay.querySelector( '.mu-gallery-grid-close' );
		const prevBtn = overlay.querySelector( '.mu-gallery-grid-nav.prev' );
		const nextBtn = overlay.querySelector( '.mu-gallery-grid-nav.next' );
		const lightboxImg = overlay.querySelector( '.mu-gallery-grid-lightbox-img' );

		let currentIndex = 0;

		/**
		 * Open the lightbox.
		 *
		 * @param {number} index Image index.
		 */
		const open = ( index ) => {
			currentIndex = index;

			const img = images[ currentIndex ];

			lightboxImg.setAttribute( 'src', img.getAttribute( 'src' ) || '' );
			lightboxImg.setAttribute( 'alt', img.getAttribute( 'alt' ) || '' );

			overlay.classList.add( 'is-visible' );
		};

		/**
		 * Close lightbox.
		 */
		const close = () => {
			overlay.classList.remove( 'is-visible' );
		};

		/**
		 * Show next image.
		 */
		const next = () => {
			currentIndex = ( currentIndex + 1 ) % images.length;
			open( currentIndex );
		};

		/**
		 * Show previous image.
		 */
		const prev = () => {
			currentIndex = ( currentIndex - 1 + images.length ) % images.length;
			open( currentIndex );
		};

		images.forEach( ( img, idx ) => {
			img.style.cursor = 'pointer';
			img.addEventListener( 'click', () => open( idx ) );
		} );

		closeBtn.addEventListener( 'click', close );
		backdrop.addEventListener( 'click', close );

		nextBtn.addEventListener( 'click', next );
		prevBtn.addEventListener( 'click', prev );
	} );
} );
